// Mock data for The Myli Boat website

export const boatInfo = {
  name: "The Myli Boat",
  model: "Cap-Ferret, B2 Marine",
  length: "5,50 m",
  type: "Bateau à moteur",
  location: {
    name: "Port De la Pointe Rouge",
    address: "Port De la Pointe Rouge, 13008 Marseille",
    coordinates: {
      lat: 43.2434,
      lng: 5.3564
    }
  },
  contact: {
    email: "TheMyliBoat@gmail.com",
    phone: "06 44 73 16 67",
    phoneRaw: "0644731667"
  }
};

export const timeSlots = [
  {
    id: 1,
    name: "Sunset",
    icon: "Sunset",
    time: "18h - 22h",
    price: 250,
    duration: "4 heures",
    description: "Contemplez le coucher de soleil allongé sur des matelas moelleux avec coussins et plaids",
    features: ["Matelas en mousse", "Coussins", "Plaids", "Vue sur le coucher de soleil"],
    highlight: true
  },
  {
    id: 2,
    name: "Demi-journée Matinale",
    icon: "Sunrise",
    time: "9h - 13h30",
    price: 350,
    duration: "4h30",
    description: "Profitez de la fraîcheur matinale pour une escapade maritime",
    features: ["Équipement complet", "Bouées", "Paddle", "Masques"]
  },
  {
    id: 3,
    name: "Demi-journée Après-midi",
    icon: "Sun",
    time: "13h30 - 18h",
    price: 350,
    duration: "4h30",
    description: "Après-midi détente sous le soleil méditerranéen",
    features: ["Équipement complet", "Bouées", "Paddle", "Masques"]
  },
  {
    id: 4,
    name: "Journée Complète",
    icon: "Clock",
    time: "9h - 18h",
    priceSpring: 450,
    priceSummer: 550,
    duration: "9 heures",
    description: "Une journée entière d'aventure et de détente en mer",
    features: ["Tous les équipements", "Prestations culinaires disponibles"],
    note: "450€ jusqu'au 31 mai • 550€ du 1er juin au 15 septembre"
  }
];

export const culinaryServices = [
  {
    id: 1,
    name: "Petits Fours",
    icon: "Cookie",
    description: "Sélection de petits fours gourmands"
  },
  {
    id: 2,
    name: "Verrines",
    icon: "Wine",
    description: "Verrines raffinées et savoureuses"
  },
  {
    id: 3,
    name: "Plateaux de Charcuterie",
    icon: "Beef",
    description: "Charcuterie fine et fromages sélectionnés"
  },
  {
    id: 4,
    name: "Barbecue",
    icon: "Flame",
    description: "Location de barbecue pour grillades en mer"
  },
  {
    id: 5,
    name: "Plateaux de Fruits",
    icon: "Apple",
    description: "Fruits frais de saison"
  }
];

export const equipment = [
  {
    id: 1,
    name: "Bouées",
    icon: "LifeBuoy",
    description: "Bouées de sécurité et détente"
  },
  {
    id: 2,
    name: "Paddle",
    icon: "Waves",
    description: "Stand-up paddle disponible"
  },
  {
    id: 3,
    name: "Masques de plongée",
    icon: "Glasses",
    description: "Pour explorer les fonds marins"
  },
  {
    id: 4,
    name: "Équipement Sunset",
    icon: "Armchair",
    description: "Matelas mousse, coussins et plaids"
  }
];

export const gallery = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_marine-reserve-app/artifacts/ntjcr0f4_IMG_1510.jpeg",
    alt: "Expérience Sunset - Contemplation du coucher de soleil"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_marine-reserve-app/artifacts/jap76znk_IMG_3234.jpeg",
    alt: "The Myli Boat - Expérience Sunset romantique"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_marine-reserve-app/artifacts/sbowj816_IMG_1382.jpeg",
    alt: "Prestation Barbecue dans les calanques"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_marine-reserve-app/artifacts/8cnhmmnr_dji_fly_20250622_184646_396_1750612437375_photo_optimized.jpeg",
    alt: "Vue aérienne des calanques - Eaux turquoise"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_marine-reserve-app/artifacts/owos6trl_D3A3BDC6-CF41-441E-8A4F-92F76B4C1572.jpeg",
    alt: "Navigation dans les calanques de Marseille"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_marine-reserve-app/artifacts/elzb4xp5_IMG_3823.jpeg",
    alt: "Plateau de fruits frais - Prestations culinaires"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sophie M.",
    rating: 5,
    comment: "Une expérience inoubliable ! Le coucher de soleil était magnifique et le service impeccable.",
    date: "Août 2024"
  },
  {
    id: 2,
    name: "Marc D.",
    rating: 5,
    comment: "Parfait pour une journée en famille. Les enfants ont adoré le paddle et les bouées !",
    date: "Juillet 2024"
  },
  {
    id: 3,
    name: "Isabelle L.",
    rating: 5,
    comment: "Les prestations culinaires sont excellentes. Nous avons passé un moment magique.",
    date: "Septembre 2024"
  }
];
